export default __webpack_public_path__ + "static/media/circle.8cc211bf.glb";